import pythonApiClient from "./pythonBaseApi";

const conciliacionCamasApi = {
  conciliar: (file, proyectoId) => {
    const formData = new FormData();
    formData.append("file", file);

    return pythonApiClient.post(
      "/procesos/hoteleria/conciliacion-camas/conciliar",
      formData,
      {
        headers: {
          "X-Proyecto-ID": proyectoId,
        },
      }
    );
  },

  inactivarCamas: (camaIds) => {
    return pythonApiClient.post(
      "/procesos/hoteleria/conciliacion-camas/inactivar",
      { cama_ids: camaIds }
    );
  },
};

export default conciliacionCamasApi;
